import React from "react";
import MaskedInput from 'react-text-mask'
import moment from 'moment'

class DateInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    handleChange(e) {
        this.setState({
            //value : moment(e.target.value).format('YYYY-MM-DD'),
            value: e.target.value,
        }, this.props.onChange.bind(null, moment.utc(e.target.value, 'MM/DD/YYYY', true).format('YYYY-MM-DD')));
    }

    render() {
        return (
            <MaskedInput
                mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
                className={this.props.classes.input}
                placeholder="MM/DD/YYYY"
                guide={true}
                id="dob"
                value={this.state.value}
                onChange={this.handleChange.bind(this)}
                onBlur={this.props.onBlur.bind(null, this.state.value)}
                onKeyDown={this.props.onKeyDown}
            />
        );
    }
};

DateInput.defaultProps = {
    classes: {},
    name: '',
    id: '',
    value: '',
    data: '',
    placeholder: '',
    onChange: () => {},
    onBlur: () => {},
    onKeyDown: () => {}
};

export default DateInput;